export default {
  name: 'ActionBlock',
  data: function data() {
    return {
      isHovered: false
    };
  },
  computed: {
    isMobile: function isMobile() {
      var _window;
      if (!process.client) {
        return false;
      }
      return (_window = window) === null || _window === void 0 || (_window = _window.$nuxt) === null || _window === void 0 ? void 0 : _window.$breakpoint.smAndDown;
    }
  },
  methods: {
    handleMouseEnter: function handleMouseEnter() {
      if (this.isMobile) {
        return;
      }
      this.isHovered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      if (this.isMobile) {
        return;
      }
      this.isHovered = false;
    }
  }
};